<template>
    <div id="cp-agent-login">
    	<div class="inner">

	    	<Login v-if="state == 'login'" @change-state="changeState" />
	    	<ForgotPassword v-if="state == 'forgot'" @change-state="changeState" />
	    	<ResetPassword v-if="state == 'reset'" @change-state="changeState" />

    	</div>
    </div>
</template>

<script>
import Login from './components/Login.vue';
import ForgotPassword from './components/ForgotPassword.vue';
import ResetPassword from './components/ResetPassword.vue';

//
export default {
	name: 'AgentLogin',
	created() {

        //if the reset query param is set, show the reset password form instead
        if( this.hasResetKey ) {
        	this.state = "reset";
        }

    },
	components: {
		Login,
		ForgotPassword,
		ResetPassword
	},
	data() {
        return {
        	state: 'login'
        };
    },
    computed: {
		queryParams() {
			return new URLSearchParams(window.location.search);
		},
		hasResetKey() {
			return (this.queryParams.get('reset') && this.queryParams.get('email'));
		}
	},
	methods: {

		//
		changeState( state ) {
			this.state = state;
		}

	}
};
</script>

<style lang="scss">
@import '../node_modules/bootstrap/scss/functions';
@import '../node_modules/bootstrap/scss/bootstrap';
@import '../styles/app.scss';

#cp-agent-login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner {
        position: relative;
        width: 450px;
        max-width: 80%;
        background-color: #fff;
        padding: 30px;
    }

    .top {
        margin-bottom: 30px;
    }

    .inprow {
        margin-bottom: 30px;
        &:last-child {
            margin-bottom: 0;
        }

        span {
            font-size: 12px;
        }

        &.err {
            color: red;
        }
    }

    label {
        display: block;
    }

    input[type=text],
    input[type=email],
    input[type=password] {
        width: 100%;
    }
}
</style>
